import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {NoStyleButton} from '@vio/atlas/src/components/designSystem/helpers/NoStyleButton'
import {Icon} from '@vio/atlas/src/components/designSystem/Icon'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import {cssTheme} from '@vio/atlas/src/themes'
import {useDispatchTeamEvent} from '@vio/core/src/analytics/hooks/useDispatchTeamEvent'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'

import {aiReviewsMessages} from '../constants'

type Feedback = 'positive' | 'negative'

const IconContainer = styled(NoStyleButton)`
  height: ${cssTheme.layout.spacing.s700};
  width: ${cssTheme.layout.spacing.s700};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  &.--thumbs-down {
    transform: scaleY(-1);
  }
`

interface Props {
  sourceComponent?: string
}
export const AiPoweredReviewsFeedback: React.FC<Props> = ({
  sourceComponent
}) => {
  const {formatMessage} = useIntl()
  const dispatchTeamEvent = useDispatchTeamEvent()

  const [feedbackSubmitted, setFeedbackSubmitted] = useState<Feedback | null>()
  const handleApplyFeedback = (feedback: Feedback) => {
    setFeedbackSubmitted(feedback)
    dispatchTeamEvent(
      trackEvent({
        category: Category.User,
        entity: Entity.AiReviewSummaryFeedback,
        action: Action.Clicked,
        payload: {feedback, category: sourceComponent}
      })
    )
  }

  if (feedbackSubmitted)
    return (
      <Box display="flex" gap="s300" alignItems="center" height="s700">
        <Text variant="bodyXS" colorPath="content.neutral.secondary">
          {formatMessage(aiReviewsMessages.thanksForLettingUsKnow)}
        </Text>
      </Box>
    )

  return (
    <Box display="flex" gap="s300" alignItems="center">
      <Text variant="bodyXS" colorPath="content.neutral.secondary">
        {formatMessage(aiReviewsMessages.wasThisHelpful)}
      </Text>
      <Box display="flex" gap="s100">
        <IconContainer onClick={() => handleApplyFeedback('positive')}>
          <Icon name="ThumbsUp" size="sm" />
        </IconContainer>
        <IconContainer
          className="--thumbs-down"
          onClick={() => handleApplyFeedback('negative')}
        >
          <Icon name="ThumbsUp" size="sm" />
        </IconContainer>
      </Box>
    </Box>
  )
}
